
/*
 * mkb-framework
 * ============================================================================
 * Module App Fassade
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */

define('app.facade',['require','exports','module','app','components/aktuelles/index'],function(require, exports, module) {

	'use strict';

	var app = require('app');


	var $window = $(window);
	var $body = $('body');

	var Aktuelles = require('components/aktuelles/index');

	var backboneView = null;
	var moduleView = null;

	var Fassade = function() {


		app.initializeLayout = false;
		var mainLayout = null;

		var setupApplication = function() {

			var aktuelles = new Aktuelles.Views.ModuleView();
			aktuelles.init();

			app.initializeLayout = true;

			if (app.phone) {

				//initOrientationChange();

			}else{

				//initResize();
			}
		};

		var initialize = function() {

			console.log('initialize: ', 'Fassade');

		};

		this.init = function() {

			console.log('init: ', 'Fassade');
			setupApplication();

		};

		initialize();
	};

	module.exports = Fassade;

});
